import { render, staticRenderFns } from "./EmailOnboardingProvider.vue?vue&type=template&id=1cfd3a1a&scoped=true&"
import script from "./EmailOnboardingProvider.vue?vue&type=script&lang=js&"
export * from "./EmailOnboardingProvider.vue?vue&type=script&lang=js&"
import style0 from "./EmailOnboardingProvider.vue?vue&type=style&index=0&id=1cfd3a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfd3a1a",
  null
  
)

export default component.exports